"use client";

import { useState, type FormEvent } from "react";
import { subscribeNewsletter, type NewsletterState } from "@/app/actions/newsletter";

export default function NewsletterForm() {
  const [state, setState] = useState<NewsletterState>({ status: "idle" });
  const [isPending, setIsPending] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setIsPending(true);
    const form = e.currentTarget;
    const formData = new FormData(form);
    try {
      const result = await subscribeNewsletter(state, formData);
      setState(result);
      if (result.status === "success") form.reset();
    } catch {
      setState({ status: "error", message: "Hubo un error. Intentá de nuevo más tarde." });
    } finally {
      setIsPending(false);
    }
  }

  if (state.status === "success") {
    return (
      <p className="text-[clamp(13px,1.2vw,16px)] text-[color:var(--color-white)] font-medium">
        {state.message}
      </p>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3" noValidate>
      <input
        type="email"
        name="email"
        placeholder="Enter your email address here"
        aria-label="Email para newsletter"
        required
        className="h-[clamp(40px,3.2vw,48px)] w-full max-w-[280px] rounded-[2px] border-0 bg-[color:var(--color-white)] px-4 text-[color:var(--color-black)] placeholder:text-[#6b7280] text-[clamp(13px,1.2vw,16px)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-white)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--color-red)]"
      />
      {state.status === "error" && (
        <p role="alert" className="text-[clamp(11px,1vw,13px)] text-[color:var(--color-white)] opacity-90">
          {state.message}
        </p>
      )}
      <button
        type="submit"
        disabled={isPending}
        className="h-[clamp(40px,3.2vw,48px)] w-full max-w-[280px] rounded-[2px] bg-[color:var(--color-black)] font-medium text-[clamp(13px,1.2vw,16px)] text-[color:var(--color-white)] hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--color-white)] transition-opacity duration-200 motion-reduce:transition-none disabled:opacity-60"
      >
        {isPending ? "…" : "sign up"}
      </button>
    </form>
  );
}
